import {
  SpotifyLogo,
  ApplePodcastsLogo,
  RssSimple,
} from '@phosphor-icons/react';
import { ExternalLink } from 'shared/types';
import { ICON_SIZE } from '../constants/common';

export type PodcastProvider = 'spotify' | 'apple' | 'rss';

export const PODCAST_PROVIDERS: PodcastProvider[] = ['spotify', 'apple', 'rss'];

export const PODCAST_PROVIDER_MAP: Record<PodcastProvider, ExternalLink> = {
  spotify: {
    icon: <SpotifyLogo size={ICON_SIZE} />,
    label: 'Spotify',
    href: 'https://open.spotify.com/show/72STqrlr1OPcbv7yYutgpM',
  },
  apple: {
    icon: <ApplePodcastsLogo size={ICON_SIZE} />,
    label: 'Apple',
    href: 'https://podcasts.apple.com/ca/podcast/moms-myths-and-mimosas/id1894838802',
  },
  rss: {
    icon: <RssSimple size={ICON_SIZE} />,
    label: 'RSS',
    href: 'https://feeds.buzzsprout.com/2607590.rss',
    copyable: true,
  },
};
